import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import EducationCard from "./EducationCard";
import ExperienceCard from "./ExperienceCard";
import AchievementCard from "./AchievementCard";

function Education() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My <strong className="purple">Education </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here is my educational background.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <EducationCard
              degree="Bachelor of Technology"
              institution="Computer Science Engineering"
              duration="2023 - 2027"
              score="CGPA: 8.172/10"
            />
          </Col>
          <Col md={6} className="project-card">
            <EducationCard
              degree="Higher Secondary (12th)"
              institution="Science Stream"
              duration="2022 - 2023"
              score="Percentage: 86%"
            />
          </Col>
          <Col md={6} className="project-card">
            <EducationCard
              degree="Secondary (10th)"
              institution=""
              duration="2021 - 2022"
              score="Percentage: 97.8%"
            />
          </Col>
        </Row>

        <h1 className="project-heading" style={{ paddingTop: "50px" }}>
          Work <strong className="purple">Experience </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <ExperienceCard
              role="Event Head"
              company="GeekRoom"
              duration="January 2025 - Present"
              description="Led and managed technical and community events. Coordinated teams, handled planning and execution, and ensured smooth event operations. Focused on student engagement, collaboration, and knowledge sharing."
            />
          </Col>
          <Col md={6} className="project-card">
            <ExperienceCard
              role="Chief Marketing Officer (CMO)"
              company="HandiSketch"
              duration="December 2025 - Present"
              description="Responsible for marketing strategy, branding, and digital presence. Worked on content planning, outreach, and audience engagement to grow the platform."
            />
          </Col>
        </Row>

        <h1 className="project-heading" style={{ paddingTop: "50px" }}>
          <strong className="purple">Achievements </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={6} className="project-card">
            <AchievementCard
              title="AWS Certified Cloud Practitioner"
              description="Successfully earned the AWS Cloud Practitioner certification. Gained foundational knowledge of cloud computing concepts, AWS core services, security, and pricing."
            />
          </Col>
          <Col md={6} className="project-card">
            <AchievementCard
              title="InnoTech'25 – Runner Up"
              description="Secured Runner-Up position at InnoTech'25 for a team-based technical project. Demonstrated problem-solving, teamwork, and practical application of technical skills."
            />
          </Col>
          <Col md={6} className="project-card">
            <AchievementCard
              title="Infosys Springboard – Spring Boot Training"
              description="Completed Infosys Springboard training focused on Spring Boot. Gained exposure to backend development concepts and enterprise-level application structure."
            />
          </Col>
          <Col md={6} className="project-card">
            <AchievementCard
              title="Electric Vehicle Internship Completion"
              description="Successfully completed an internship related to Electric Vehicle (EV) technologies. Gained practical exposure to EV concepts, systems, and real-world applications."
            />
          </Col>
          <Col md={6} className="project-card">
            <AchievementCard
              title="Leadership & Community Involvement"
              description="Served as Event Head at GeekRoom, contributing to the planning and execution of technical and community-driven events. Played an active role in team coordination, event management, and student engagement."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Education;
